<template>
  <el-drawer
    v-if="isMobile"
    class="sidebar-drawer"
    :model-value="layoutStore.mobileSidebarOpen"
    direction="ltr"
    size="260px"
    :with-header="false"
    @update:model-value="layoutStore.closeMobileSidebar"
  >
    <SidebarMenu
      :collapsed="false"
      @navigate="layoutStore.closeMobileSidebar"
    />
  </el-drawer>

  <aside
    v-else
    class="hidden lg:flex flex-col self-start sticky top-0 z-10 shrink-0 bg-white border-r border-untitled-gray-200 transition-all duration-300 h-screen"
    :class="layoutStore.sidebarCollapsed ? 'w-[64px]' : 'w-[260px]'"
  >
    <SidebarMenu :collapsed="layoutStore.sidebarCollapsed" />
  </aside>
</template>

<script setup>
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import { ElDrawer } from "element-plus";
import { useLayoutStore } from "@/stores/useLayoutStore";
import SidebarMenu from "./SidebarMenu.vue";

const layoutStore = useLayoutStore();
const { width } = useWindowSize();
const isMobile = computed(() => width.value < 1024);
</script>

<style>
.sidebar-drawer .el-drawer__body {
  padding: 0 !important;
}
</style>
